import * as z from "zod";

export const cancelWithdrawalOrder = {
  name: "cancelWithdrawalOrder" as const,
  input: z.object({ withdrawalId: z.string() }),
  output: z.null(),
};
